import { createSelector } from 'reselect'

const getUserDetails = (state: any) => state.userDetails

/** A Redux selector to retrieve user email preferences Data
 * @param state - The Redux state
 * @param {object} - user email preferences Data.
 */

 export const selectUserEmailPreferences = createSelector(
  getUserDetails,
  (data) => data && data.userEmailPreferences && data.userEmailPreferences.data ? data.userEmailPreferences.data : null
)

/** A Redux selector to retrieve user email preferences loading
 * @param state - The Redux state
 * @param {Boolean} - user email preferences loading.
 */

export const selectUserEmailPreferencesLoading = createSelector(
  getUserDetails,
  (data) => data && data.userEmailPreferences && data.userEmailPreferences.status ? data.userEmailPreferences.status.inProgress : null
)

export const selectUserEmailPreferencesAccordionFlag = createSelector(
  getUserDetails,
  (data) => data && data.userEmailPreferences && data.userEmailPreferences.status ? data.userEmailPreferences.status.accordionFlag : null
)

/** A Redux selector to retrieve user roles Data
 * @param state - The Redux state
 * @param {object} - user roles Data.
 */

 export const selectUserRoles = createSelector(
  getUserDetails,
  (data) => data && data.userRoles && data.userRoles.data ? data.userRoles.data : null
)

/** A Redux selector to retrieve user roles loading
 * @param state - The Redux state
 * @param {Boolean} - user roles loading.
 */

 export const selectUserRolesLoading = createSelector(
  getUserDetails,
  (data) => data && data.userRoles && data.userRoles.status ? data.userRoles.status.inProgress : null
)

/** A Redux selector to retrieve updated user roles loading
 * @param state - The Redux state
 * @param {Boolean} - updated user roles loading.
 */

 export const selectUpdatedUserRolesLoading = createSelector(
  getUserDetails,
  (data) => data && data.updateUserRoles && data.updateUserRoles.inProgress ? data.updateUserRoles.inProgress : null
)

/** A Redux selector to retrieve reset user password loading
 * @param state - The Redux state
 * @param {Boolean} - reset user password loading.
 */

 export const selectResetUserPasswordLoading = createSelector(
  getUserDetails,
  (data) => data && data.resetUserPassword ? data.resetUserPassword.inProgress : null
)

/** A Redux selector to retrieve user profile details Data
 * @param state - The Redux state
 * @param {object} - user profile details Data.
 */

 export const selectUserProfileDetails = createSelector(
  getUserDetails,
  (data) => data && data.userProfileDetails ? data.userProfileDetails.data : null
)

/** A Redux selector to retrieve user profile details Data loading state
 * @param state - The Redux state
 * @param {Boolean} - user profile details Data loading state.
 */

export const selectUserProfileDetailsLoading = createSelector(
  getUserDetails,
  (data) => data && data.userProfileDetails ? data.userProfileDetails.status.inProgress : false
)

/** A Redux selector to retrieve user profile details update progress
 * @param state - The Redux state
 * @param {Boolean} - user profile update progress
 */

export const selectUserProfileDetailsUpdateInProgress = createSelector(
  getUserDetails,
  (data) => data && data.updateProfileDetails ? data.updateProfileDetails.inProgress : false
)

/** A Redux selector to retrieve user profile details updated data
 * @param state - The Redux state
 * @param {Object} - profile details updated data
 */

export const selectUserProfileDetailsUpdatedData = createSelector(
  getUserDetails,
  (data) => data && data.updateProfileDetails ? data.updateProfileDetails.data : false
)

/** A Redux selector to retrieve update email preference's loading
 * @param state - The Redux state
 * @param {Boolean} - update email preference's loading.
 */

export const selectUpdateEmailPreferencesLoading = createSelector(
  getUserDetails,
  (data) => data && data.updateEmailPreferences ? data.updateEmailPreferences.inProgress : null
)

export const selectUpdateEmailPreferencesAccordionFlag = createSelector(
  getUserDetails,
  (data) => data && data.updateEmailPreferences ? data.updateEmailPreferences.accordionFlag : null
)
